/** @prettier */

//interface import
import * as apiIF from '../Type/api';

/**
 * サイト情報の課金情報をチェックして、課金状態のGWが存在する場合trueを返します。
 * @param billingStatus:　サイトの課金状態
 * @return billingStatusが 'anyUnpaid' または 'paid' の場合、trueを返す。それ以外の場合は無効（falseを返す）
 */
export function checkSiteInfoBillingStatus(
  billingStatus: apiIF.res.getCompositionsSitesBySiteID['billing-status']
) {
  return billingStatus === 'anyUnpaid' || billingStatus === 'paid';
}

/**
 * ゲートウェイ情報の課金情報をチェックして、課金状態のGWの場合trueを返します。
 * @param billingStatus:　サイトの課金状態
 * @return billingStatusが 'unpaid' の場合、無課金状態としてfalseを返す。それ以外の場合は課金状態としてtrueを返す
 */
export function checkGwInfoBillingStatus(
  billingStatus: apiIF.resParameters.gatewayInformations['billing-status']
) {
  return billingStatus !== 'unpaid';
}
